import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toast";
//import * as auth from "../Auth";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import Uploady, { useItemProgressListener } from "@rpldy/uploady";
import { getMockSenderEnhancer } from "@rpldy/mock-sender";
import UploadButton from "@rpldy/upload-button";
import UploadPreview from "@rpldy/upload-preview";
import ImageUploader from "react-images-upload";
import Toggle from "./../../themeToggle";

import "./style.css";
import {
  CreditCardIcon,
  KeyIcon,
  UserCircleIcon,
  UserGroupIcon,
  ViewGridAddIcon,
} from "@heroicons/react/outline";
import Languageselect from "../login/Languageselect";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");

function Preference({ t }) {
  const mockSenderEnhancer = getMockSenderEnhancer();

  return (
    <div className="min-h-screen w-full flex dark:bg-gray-700  bg-gray-200">
      <div className="flex-1 flex  justify-center dark:bg-gray-800 mt-4  bg-white shadow sm:rounded-md sm:overflow-hidden mr-8 ">
        <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5 w-full pl-40">
          <div>
            <div>
              <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
                {t("preference.title")}
              </h2>
            </div>

            <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
              <div className="sm:grid sm:grid-cols-3  relative sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 py-4  ">
                <label
                  htmlFor="photo"
                  className="dark:text-white pl-2 pt-4 block text-sm font-medium text-gray-700"
                >
                  {t("preference.langue")}
                </label>
                <div className="   sm:col-span-2">
                  <div className="mt-1 relative sm:mt-0 sm:col-span-2">
                    <div className="mt-1">
                      <Languageselect />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 py-4  ">
            <label
              htmlFor="username"
              className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              {t("preference.theme")}
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2">
              <div className="mt-1">
                <Toggle />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default withTranslation("common")(Preference);
